






































import {
  Component,
  Vue
} from "@/shared/vuepack";

import { useManagedExpenseStore } from "@/employee/store/managedExpense";
import { ManagedExpenseFilterType } from "@/shared/types";
import { HsabExpenseManagement } from "@/employee/route-names";
import { useHsabAccountsStore } from "@/employee/store/hsabAccounts";

@Component({
  computed: {
    ManagedExpenseFilterType () {
      return ManagedExpenseFilterType;
    }
  }
})
export default class ManagedExpenseFilters extends Vue {
  managedExpensesStore = useManagedExpenseStore();
  hsabAccountsStore = useHsabAccountsStore();

  created () {
    this.managedExpensesStore.loadUserHasHealthPlanExpense();
  }

  onFilterClicked (filter: ManagedExpenseFilterType) {
    this.$router.replace({ name: HsabExpenseManagement, params: { filter }});
  }

  get showHealthPlanFilter () {
    return this.managedExpensesStore.userHasHealthPlanExpense;
  }

}
